import { rgbToHex } from '@material-ui/core'
import _ from 'lodash'
import { addAlpha } from '../constants/CardComponent'
import { isImmutable, Map } from 'immutable'

const ALPHA_HEX_RE = /^(#[a-f0-9]{8})$/i
const HEX_RE = /^(#[a-f0-9]{3}|[a-f0-9]{6})$/i
const HEX_RE_NO_SHARP = /^([a-f0-9]{3}|[a-f0-9]{6}|[a-f0-9]{8})$/i

export const SMARTV_FIELDS_KEY = [
  'SmartVLoginField',
  'SmartVVerfField',
  'SmartVRegField',
  'SmartVProfileField',
  'SmartVLoginFormField',
]

export const isHex = (color) => ALPHA_HEX_RE.test(color) || HEX_RE.test(color)

export const colorToHex = (color) => {
  if (HEX_RE_NO_SHARP.test(color)) {
    color = `#${color}`
    if (HEX_RE.test(color)) {
      color = addAlpha(color, 1)
    }
  }
  if (ALPHA_HEX_RE.test(color)) {
    return color
  } else if (HEX_RE.test(color)) {
    return addAlpha(color, 1)
  } else {
    try {
      let hexColor = rgbToHex(color)
      hexColor = String(hexColor).substr(0, 7)
      if (String(color).indexOf('rgba') !== -1) {
        const re = /^.*,([0-9\.]*)\)$/
        const m = re.exec(color)
        if (m && m[1]) {
          const alpha = parseFloat(m[1])
          if (!_.isNaN(alpha)) {
            return addAlpha(hexColor, alpha)
          }
        }
      }
      if (ALPHA_HEX_RE.test(hexColor)) {
        return hexColor
      } else {
        return addAlpha(hexColor, 1)
      }
    } catch (error) {
      return color
    }
  }
}

const GET_CONFIG = [
  {
    type: 'color',
    keys: ['color', 'backgroundColor', 'borderColor', 'fill', 'stroke', 'scrollBarColor', 'thumbColor'],
  },
  {
    type: 'font',
    keys: ['fontFamily'],
  },
  {
    type: 'gradient',
    keys: ['background', 'scrollBarImage', 'thumbImage'],
  },
]

const getValues = (obj, key) =>
  _.reduce(
    obj,
    (r, v, k) => {
      if (_.isObject(v)) {
        return _.merge({}, r, getValues(v, `${key}.${k}`))
      } else {
        let ret = { ...r }
        _.each(GET_CONFIG, (conf) => {
          if (conf.keys.indexOf(k) !== -1) {
            let val = v
            if (conf.type === 'color') {
              val = String(colorToHex(v)).toLowerCase()
            }
            ret = _.merge(ret, {
              [conf.type]: {
                [`${key}.${k}`]: val,
              },
            })
          }
        })
        return ret
      }
    },
    {}
  )

export const processThemeData = (theme) => {
  let result = {}

  const rootTheme = isImmutable(theme) ? theme.get('lg', Map()).toJS() : _.get(theme, 'lg', {})
  const page404Theme = isImmutable(theme) ? theme.get('page404', Map()).toJS() : _.get(theme, 'page404', {})
  result = _.merge(result, getValues(rootTheme, 'lg'), getValues(page404Theme, 'page404'))

  const raw = {
    theme,
    config: result,
    ..._.reduce(
      result,
      (r, v, k) => ({
        ...r,
        [k]: _.reduce(_.uniq(_.compact(_.values(v))), (r, v) => ({ ...r, [v]: v }), {}),
      }),
      {}
    ),
  }

  return raw
}
